import styled from 'styled-components'

export const Container = styled.div`
  padding: ${props => props.theme.spacing.sp16};
  padding-bottom: 0px;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};

  //to override the default styles of the DeliverySteps component
  div {
    min-height: ${props => props.theme.size.S};
    min-width: ${props => props.theme.size.S};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp16};
  }

  p {
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    margin: 0;
  }
`
